// Put your JS here

// import Isotope from 'isotope-layout';
// import jQueryBridget from 'jquery-bridget';
// import imagesLoaded from 'imagesloaded';

var Isotope = require('isotope-layout');
var jQueryBridget = require('jquery-bridget');
var imagesLoaded = require('imagesloaded');
import 'slick-carousel/slick/slick.min.js';

//import 'https://cdn.donorfy.com/wwjs/stripepayments_2022.12.2.js';

import { Foundation, Drilldown } from 'foundation-sites';

Foundation.addToJquery($);

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var mirai = {
    // All pages
    common: {
      init: function () {
        $(document).foundation();

        // Container Float (Floating Container)
        function containerFloat() {
          var containerSize = 1160;
          var containerSizeMax = 1280;
          var windowWidth = $(window).width();

          if (windowWidth >= containerSize) {
            var fivePercent = windowWidth / 10 / 2;
            var remainingWidth = windowWidth - containerSize;
            var float = remainingWidth / 2;

            if (fivePercent > float) {
              $('.container--float-left').css({
                width: windowWidth - fivePercent + 'px',
                'max-width': '100%',
                margin: '0 0 0 ' + fivePercent + 'px',
              });
            } else {
              $('.container--float-left').css({
                width: windowWidth - float + 'px',
                'max-width': '100%',
                margin: '0 0 0 ' + float + 'px',
              });
            }
          } else {
            $('.container--float').css({
              width: '85%',
              'max-width': containerSize + 'px',
              margin: '0 auto',
              padding: '0',
            });
          }
        }

        //isotope masonry

        $('.posts__grid').addClass('masonry');
        //$('.posts__grid').wrapInner( "<div class='masonry'></div>");

        jQueryBridget('isotope', Isotope, $);

        imagesLoaded.makeJQueryPlugin($);
        //jQueryBridget( 'imagesloaded', imagesloaded, $ );

        document.addEventListener('facetwp-loaded', function () {
          console.log('fwp loaded');
 
          /* var $masonry_container = $('.post-type-archive-event .posts__grid');

          $masonry_container.isotope('destroy');

          $masonry_container.isotope({
            // options
            itemSelector: '.posts__grid-post',
            layoutMode: 'fitRows',
            originTop: true,
            originLeft: true,
            // masonry: {
            // 	columnWidth: '.posts__grid-post',
            // }
          });

          //$masonry_container.isotope('appended', $masonry_container.find('.posts__grid-post'));

          $masonry_container.isotope('layout');

          $masonry_container.imagesLoaded().progress(function () {
            $masonry_container.isotope('layout');
          }); */

          // var $grid = $('.masonry').imagesLoaded(function () {
          //   $grid.isotope({
          //     layoutMode: 'masonry',
          //     itemSelector: '.posts__grid-post',
          //     isOriginLeft: true,
          //   });
          // });
          //fUtil('body').trigger('jetpack-lazy-images-load');
        });

        // Hero Event Sizing
        function heroEventSizing(initialRun) {
          if ($(window).width() >= 1160) {
            var heroUpperHeight = $(
              '.block__hero--project-event .hero__upper'
            ).outerHeight();
            // console.log(heroUpperHeight);
            var heroUpperRightHeight = $(
              '.block__hero--project-event .hero__upper-right'
            ).outerHeight();
            // console.log(heroUpperRightHeight);
            var heroDetailsHeight = $(
              '.block__hero--project-event .hero__details'
            ).outerHeight();
            // console.log(heroDetailsHeight);
            // console.log(heroDetailsHeight + 220);

            // 	var heroBgHeight = $('.block__hero--project-event .hero__bg').height();
            // 	var headerSize = $('.block__hero--project-event h1').outerHeight(true);
            // 	var detailsHeight = 0

            // 	if (initialRun == true) {
            // 		// On Load
            // 		detailsHeight = (heroBgHeight - headerSize) + 140;
            // 	} else {
            // 		// On Resize
            // 		detailsHeight = (heroBgHeight - headerSize) - 40;
            // 	}

            // 	$('.block__hero--project-event .hero__details').css({
            // 		"min-height": detailsHeight + "px",
            // 	});

            // 	$('.block__hero--project-event .hero__details, .block__hero--project-event .hero__description').addClass('loaded');
          }
        }

        // Hero Large Standard Image Sizing
        function heroLargeStandardSizing() {
          var windowWidth = $(window).width();
          var containerSize = 768;
          var contentWidth = $('.block__hero--large-standard')
            .find($('.hero__content'))
            .outerWidth();
          var contentWidthHalf = contentWidth / 2;

          if (windowWidth >= containerSize) {
            $('.block__hero--large-standard')
              .find($('.hero__image'))
              .css({
                width: 'calc(' + '100% - ' + contentWidthHalf + 'px)',
              });
          } else {
            $('.block__hero--large-standard').find($('.hero__image')).css({
              width: '100%',
            });
          }
        }

        // Media Library Alternate Sizing
        function mediaLibAltSizing() {
          var windowWidth = $(window).width();
          var containerSize = 1160;
          if (windowWidth >= containerSize) {
            var contentWidth = $('.block__media-library--alternative')
              .find($('.media-library__content'))
              .outerWidth(true);
            var containerFloatSize = $('.block__media-library--alternative')
              .find($('.container'))
              .outerWidth();
            var sliderWidth = containerFloatSize - contentWidth;
            $('.media-library__slider--alternative').css({
              'max-width': sliderWidth + 'px',
            });
          } else {
            $('.media-library__slider--alternative').css({
              'max-width': '100%',
            });
          }
        }

        // Reset Nav
        function resetNav() {
          $('body, .nav-mobile, .mobile-trigger span').removeClass(
            'mobile-menu-active'
          );
        }

        // Functions to run on load
        $(document).ready(function () {
          if ($('.container--float').length) {
            containerFloat();
          }
          if ($('.block__hero--project-event').length) {
            heroEventSizing(true);
          }
          if ($('.block__hero--large-standard').length) {
            heroLargeStandardSizing();
          }
          if ($('.block__media-library--alternative').length) {
            mediaLibAltSizing();
          }
        });

        // Functions to run on window resize
        // Length checks to see if page has these elements before running costly JavaScript resources
        $(window).resize(function () {
          if ($('.container--float').length) {
            containerFloat();
          }
          if ($('.block__hero--project-event').length) {
            heroEventSizing(false);
          }
          if ($('.block__hero--large-standard').length) {
            heroLargeStandardSizing();
          }
          if ($('.block__media-library--alternative').length) {
            mediaLibAltSizing();
          }
          resetNav();
        });

        // Smooth scroll to links
        /* $('a[href*="#"]:not([href="#"])').click(function () {
          var offset = -180; // <-- change the value here
          if ($(document).width() < 768) {
            offset = -80;
          } else if ($(document).width() < 1160) {
            offset = -115;
          }

          if (
            location.pathname.replace(/^\//, '') ==
              this.pathname.replace(/^\//, '') &&
            location.hostname == this.hostname
          ) {
            var target = $(this.hash);
            target = target.length
              ? target
              : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
              $('html, body').animate(
                {
                  scrollTop: target.offset().top + offset,
                },
                1000
              );
              return false;
            }
          }
        }); */

        // Hide Sub Menu when clicking outside
        /* $(document).click(function (e) {
          if (document.documentElement.clientWidth > 900) {
            e.stopPropagation();
            var container = $('.nav-primary');

            //check if the clicked area is dropDown or not
            if (container.has(e.target).length === 0) {
              $('.nav-primary li, .sub-menu').removeClass('menu-active');
            }

            if (
              $('.search-form-wrapper').hasClass('search-form-wrapper--open')
            ) {
              $('.search-form-wrapper').removeClass(
                'search-form-wrapper--open'
              );
              $('body').removeClass('search-form-open');
            }
          }
        }); */

        // Mobile Menu Functionality
       /*  $('.nav-mobile li svg').click(function () {
          var windowHeight = $(window).height();
          var submenuHeight = $(this).next('.submenu').height();

          if (submenuHeight > windowHeight - 60) {
            if (windowHeight > submenuHeight) {
              var differnce = windowHeight - submenuHeight;
              $('.offcanvas__nav').css({
                'margin-bottom': differnce + 40 + 'px',
              });
            } else {
              var differnce = submenuHeight - windowHeight;
              $('.offcanvas__nav').css({
                'margin-bottom': differnce + 120 + 'px',
              });
            }
          }
          $(this).next('.submenu').addClass('open');
        });

        $('.submenu-back').click(function () {
          $(this).closest('.submenu').removeClass('open');
          $('.offcanvas__nav').css({
            'margin-bottom': '0px',
          });
        });

        // Accessible Keyboard Arrow Navigation
        var menuItemFocus = false;
        document.addEventListener('keydown', function (event) {
          // Arrow Keys on Menu
          if (event.keyCode == 37) {
            if (menuItemFocus == true) {
              jQuery.tabPrev();
            }
          } else if (event.keyCode == 39) {
            if (menuItemFocus == true) {
              jQuery.tabNext();
            }
          }

          // Search bar close on escape key
          if (event.keyCode == 27) {
            if ($('body').hasClass('search-form-open')) {
              jQuery.tabPrev();
              $('.search-form-wrapper').removeClass(
                'search-form-wrapper--open'
              );
              $('body').removeClass('search-form-open');
            }
          }

          // Search bar close on tab key
          if (event.keyCode == 9) {
            if ($('body').hasClass('search-form-open')) {
              $('.search-form-wrapper').removeClass(
                'search-form-wrapper--open'
              );
              $('body').removeClass('search-form-open');
            }
          }
        });

        // Listen to elements that are focused
        // Get current tabbed element, check if it has a class
        // If true set global var 'menuItemFocus' to true
        document.addEventListener(
          'focus',
          function () {
            var focusedElement = document.activeElement;
            var focusedElementParent = $(focusedElement).parent();
            if ($(focusedElementParent).hasClass('menu-item')) {
              menuItemFocus = true;
            } else {
              menuItemFocus = false;
            }
          },
          true
        );

        // Submenu Functionality
        $('.nav-primary > li').click(function () {
          var $this = $(this),
            $ul = $('> ul', this);

          if (!$ul.hasClass('menu-active')) {
            // Add class to current list item
            $this.addClass('menu-active');

            // Slide down used for mobiles
            $ul.toggleClass('menu-active').slideDown();
          } else {
            $this.removeClass('menu-active');

            $ul.removeClass('menu-active');
          }
        });

        // Mobile Trigger to open Mobile Menu
        $('.mobile-trigger').click(function () {
          $(this).find('span').toggleClass('mobile-menu-active');
          $('body, .nav-mobile').toggleClass('mobile-menu-active');
        });
 */
        // Search Form Functionality
        $('.search-form-wrapper').click(function (e) {
          e.stopPropagation();
          $(this).addClass('search-form-wrapper--open');
          $('body').addClass('search-form-open');
          jQuery.tabNext();
        });

        $('.search-form-wrapper').keypress(function (event) {
          if (event.keyCode === 13) {
            $(this).addClass('search-form-wrapper--open');
            $('body').addClass('search-form-open');
            jQuery.tabNext();
          }
        });

        $('.search-form-wrapper--open').click(function (e) {
          e.stopPropagation();
        });

        $('.search-field').click(function (e) {
          e.stopPropagation();
        });

        // Login / Registration Form Swap
        $('.woocommerce-swap-account-registration-form').click(function () {
          $('#customer_login').addClass('registration-active');
        });

        $('.woocommerce-swap-account-login-form').click(function () {
          $('#customer_login').removeClass('registration-active');
        });

        // Fancybox Button Open
        $('.button--play-video').click(function () {
          var block = $(this).closest('.block');
          $(block).find('.fancybox-open').trigger('click');
        });

        // FacetWP Archive Updating
        document.addEventListener('facetwp-loaded', function () {
          if ($('body').hasClass('post-type-archive-music_arts_ideas')) {
            var categoryValue = FWP.facets.mai_categories[0];

            if (categoryValue != undefined) {
              var categoryValueUpdated = categoryValue.replace('-', ' ');
              if (categoryValue == 'talks-debates') {
                $('.block__hero .hero__content h1').text('Talks & Debates');
              } else {
                $('.block__hero .hero__content h1').text(
                  categoryValueUpdated + ' Listings'
                );
              }
            } else {
              $('.block__hero .hero__content h1').text('Music, Arts & Ideas');
            }
          } else if (
            $('body').hasClass('page-template-page-music_arts_ideas_expired')
          ) {
            var categoryValue = FWP.facets.mai_categories[0];

            if (categoryValue != undefined) {
              var categoryValueUpdated = categoryValue.replace('-', ' ');
              $('.block__hero .hero__content h1').text(
                'Expired ' + categoryValueUpdated + ' Listings'
              );
            } else {
              $('.block__hero .hero__content h1').text(
                'Expired Music, Arts & Ideas'
              );
            }
          } else if ($('body').hasClass('post-type-archive-earth_justice')) {
            var categoryValue = FWP.facets.ej_categories[0];

            if (categoryValue != undefined) {
              var categoryValueUpdated = categoryValue.replace('-', ' ');
              $('.block__hero .hero__content h1').text(
                'Earth Justice ' + categoryValueUpdated
              );
            } else {
              $('.block__hero .hero__content h1').text('Earth Justice');
            }
          } else if ($('body').hasClass('post-type-archive-social_justice')) {
            var categoryValue = FWP.facets.sj_categories[0];

            if (categoryValue != undefined) {
              var categoryValueUpdated = categoryValue.replace('-', ' ');
              $('.block__hero .hero__content h1').text(
                'Social Justice ' + categoryValueUpdated
              );
            } else {
              $('.block__hero .hero__content h1').text('Social Justice');
            }
          }
        });

        // Latest Posts List
        $('.latest-posts__post--list').mouseover(function () {
          $('.latest-posts__post--list').removeClass('selected');
          $(this).addClass('selected');
        });

        // Hero Slick Slider
        $('.block__hero--large-slider .container').slick({
          arrows: false,
          dots: true,
          slidesToShow: 1,
          autoplay: true,
          autplaySpeed: 7500,
          centerMode: true,
          fade: false,
          adaptiveHeight: false,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                fade: true,
                adaptiveHeight: true,
              },
            },
          ],
        });

        // Hero Slider Custom Nav
        $('.hero__slider-next').click(function () {
          var slickSlider = $(this).closest('.slick-slider');
          slickSlider.slick('slickNext');
        });

        // Basic Slider Slider
        $('.slider__slider').slick({
          arrows: false,
          dots: true,
          slidesToShow: 1,
          centerMode: true,
          fade: true,
          adaptiveHeight: true,
        });

        $('.slider__slide-next').click(function () {
          var slickSlider = $(this).closest('.slick-slider');
          slickSlider.slick('slickNext');
        });

        // Featured News Slider
        $('.featured-news__slider').slick({
          arrows: false,
          dots: true,
          slidesToShow: 1,
          centerMode: true,
          fade: true,
          adaptiveHeight: true,
        });

        $('.featured-news__slide-next').click(function () {
          var slickSlider = $(this).closest('.slick-slider');
          slickSlider.slick('slickNext');
        });

        // Media Library Slick Sliders
        $('.media-libary__slider--standard').slick({
          arrows: true,
          dots: false,
          slidesToShow: 3.5,
          responsive: [
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: 2.5,
              },
            },
            {
              breakpoint: 1160,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });

        $('.media-library__slider--alternative').slick({
          arrows: false,
          dots: true,
          slidesToShow: 2.75,
          centerMode: false,
          adaptiveHeight: false,
          responsive: [
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 2.25,
              },
            },
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: 1.75,
                adaptiveHeight: false,
              },
            },
            {
              breakpoint: 1160,
              settings: {
                slidesToShow: 2,
                adaptiveHeight: false,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                adaptiveHeight: true,
              },
            },
          ],
        });

        // Media Library Slider Custom Nav
        $('.media-library__controls-prev').click(function () {
          var slickSlider = $(this)
            .closest('.block__media-library')
            .find('.slick-slider');
          slickSlider.slick('slickPrev');
        });

        $('.media-library__controls-next').click(function () {
          var slickSlider = $(this)
            .closest('.block__media-library')
            .find('.slick-slider');
          slickSlider.slick('slickNext');
        });

        // Latest Posts Slick Slider
        $('.latest-posts__slider').slick({
          arrows: false,
          dots: false,
          slidesToShow: 2.5,
          adaptiveHeight: false,
          responsive: [
            {
              breakpoint: 1160,
              settings: {
                slidesToShow: 2,
                adaptiveHeight: false,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                adaptiveHeight: true,
              },
            },
          ],
        });

        // Latest Posts Slider Custom Nav
        $('.latest-posts__controls-prev').click(function () {
          var slickSlider = $(this)
            .closest('.block__latest-posts')
            .find('.slick-slider');
          slickSlider.slick('slickPrev');
        });

        $('.latest-posts__controls-next').click(function () {
          var slickSlider = $(this)
            .closest('.block__latest-posts')
            .find('.slick-slider');
          slickSlider.slick('slickNext');
        });

        // Latest Events Slick Slider
        $('.latest-events__slider').slick({
          arrows: false,
          dots: false,
          slidesToShow: 4,
          adaptiveHeight: false,
					centerMode: false,
          responsive: [
            {
              breakpoint: 1160,
              settings: {
                slidesToShow: 3,
                adaptiveHeight: false,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                adaptiveHeight: true,
              },
            },
          ],
        });

        // Latest Posts Slider Custom Nav
        $('.latest-events__controls-prev').click(function () {
          var slickSlider = $(this)
            .closest('.block__latest-events')
            .find('.slick-slider');
          slickSlider.slick('slickPrev');
        });

        $('.latest-events__controls-next').click(function () {
          var slickSlider = $(this)
            .closest('.block__latest-events')
            .find('.slick-slider');
          slickSlider.slick('slickNext');
        });

        $('.latest-events-menu').on('click', 'li', function (e) {
          //alert('click');
          e.preventDefault();
          e.stopPropagation();

          $(this).siblings().removeClass('active');
          $(this).addClass('active');

          var slickSlider = $(this)
            .closest('.block__latest-events')
            .find('.slick-slider');

          var slidestoshow = $(this).data('display');

					//alert(slidestoshow);

          if (slidestoshow == 'all') {
            //slickSlider.find('.latest-events__slider-post').show();

            // slickSlider
            //   .find('.latest-events__slider-post')
            //   .fadeOut(function () {
            //     slickSlider.find('.latest-events__slider-post').fadeIn();
            //   });
						slickSlider.slick('slickUnfilter');
          }

          if (slidestoshow == 'this_week_slide') {
            // slickSlider
            //   .find('.latest-events__slider-post')
            //   .fadeOut(function () {
            //     slickSlider.find('.this_week_slide').fadeIn();
            //   });

						slickSlider.slick('slickFilter','.this_week_slide');
          }
          if (slidestoshow == 'today_slide') {
            // slickSlider
            //   .find('.latest-events__slider-post')
            //   .fadeOut(function () {
            //     slickSlider.find('.today_slide').fadeIn();
            //   });
						slickSlider.slick('slickFilter','.today_slide');
          }

          // if(!$(this).hasClass('filtered')) {
          // 	$('.regular').slick('slickFilter',':not(.hide-slide)');
          //   $(this).addClass('filtered')
          // }
          // else {
          // 	$('.regular').slick('slickUnfilter');
          //   $(this).removeClass('filtered')
          // }
        });
        // Image Text Slick Slider

        $('.slider-text-menu').on('click', 'li', function (e) {
          //alert('click');
          e.preventDefault();
          e.stopPropagation();
          var slickSlider = $(this)
            .closest('.block__image-text')
            .find('.slick-slider');

          var index = $(this).index();

          slickSlider.slick('slickGoTo', index);
          slickSlider.slick('slickNext');
        });

        $('.image-text-slider').on(
          'beforeChange',
          function (e, s, currentSlide, nextSlide) {
            //let previousSlideIndex = currentSlideIndex - 1;
            //console.log(previousSlideIndex);

            var menu = $(this).closest('.block__image-text').find('.menu');

            menu.find('li').removeClass('active');

            menu.find('li').eq(nextSlide).addClass('active');
          }
        );

        $('.image-text-slider').slick({
          arrows: false,
          dots: false,
          slidesToShow: 1,
          adaptiveHeight: false,
          fade: true,
        });

        // Latest Posts Slider Custom Nav
        $('.image-text__controls-prev').click(function () {
          var slickSlider = $(this)
            .closest('.block__image-text')
            .find('.slick-slider');
          slickSlider.slick('slickPrev');
        });

        $('.image-text__controls-next').click(function () {
          var slickSlider = $(this)
            .closest('.block__image-text')
            .find('.slick-slider');
          slickSlider.slick('slickNext');
        });

        $('.hero-quote-slider').slick({
          arrows: false,
          dots: true,
          slidesToShow: 1,
          adaptiveHeight: false,
          autoplay: true,
          autplaySpeed: 7500,
          centerMode: true,
          fade: true,
        });

        // Documents
        $('.documents__category-selector__dropdown p').click(function () {
          var listName = $(this).data('list');
          var innerHTML = $(this).text();
          $('.documents__list').removeClass('open');
          $('.documents__list--' + listName).addClass('open');
          $('.documents__category-selector__selected h3').text(innerHTML);
        });

        $('.documents__category-selector__dropdown p').keypress(function (
          event
        ) {
          if (event.keyCode === 13) {
            var listName = $(this).data('list');
            var innerHTML = $(this).text();
            $('.documents__list').removeClass('open');
            $('.documents__list--' + listName).addClass('open');
            $('.documents__category-selector__selected h3').text(innerHTML);
          }
        });

        if ('IntersectionObserver' in window) {
          // Intersection Observer Callback Function
          var blockObserverCallback = function (entries, observer) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                if (entry.target.classList.contains('chapters-obsv')) {
                  var chapter = $(entry.target).data('chapter');
                  $(entry.target)
                    .closest('.text__chapters')
                    .find('.chapters-nav')
                    .removeClass('active');
                  // $('.chapters-nav').removeClass('active');
                  $('.chapters-nav-' + chapter).addClass('active');
                } else {
                  entry.target.classList.add('in-view');
                  observer.unobserve(entry.target);
                }
              }
            });
          };

          // Intersection Observer Options
          var headerPercent =
            97 - ($('.header').outerHeight() / $(window).height()) * 100;
          var blockObserverOptions = {
            root: null,
            rootMargin: '0% 0% -' + headerPercent + '% 0%',
            threshold: 0,
          };

          // Creation of Intersection Observer
          var blockObserver = new IntersectionObserver(
            blockObserverCallback,
            blockObserverOptions
          );
          // Intersection Observer Elements to observe
          var blockObserverElements = document.querySelectorAll(
            '.block, .chapters-obsv'
          );
          // Pass Elements to Observer
          blockObserverElements.forEach(function (blockObserverElement) {
            blockObserver.observe(blockObserverElement);
          });
        } else {
          blockObserverElements = document.querySelectorAll('.block');
          blockObserverElements.forEach(function (blockObserverElement) {
            blockObserverElement.classList.add('in-view');
          });
        }

        (function ($) {
          $(document).on('facetwp-loaded', function () {
            $('.facetwp-type-dropdown select').each(function () {
              if ($(this).children('option').length == 1) {
                $(this).closest('.facetwp-type-dropdown').hide();
              } else {
                $(this).closest('.facetwp-type-dropdown').show();
              }
            });

            $('.facetwp-facet-ww_categories option').each(function () {
              if ($(this).val() == '') {
                $(this).remove();
              }
            });
          });
        })(jQuery);

        // wrap embeds in div
        $('iframe[src^="https://www.youtube.com/embed/"]').wrap(
          '<div class="embed"></div>'
        );
        $('iframe[src^="https://player.vimeo.com/video"]').wrap(
          '<div class="embed"></div>'
        );

        // Google Map
        function new_map($el) {
          // var
          var $markers = $el.find('.marker');

          // vars
          var args = {
            zoom: 18,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: true,
            navigationControl: false,
            mapTypeControl: false,
            scaleControl: true,
            draggable: true,
            styles: [
              {
                featureType: 'all',
                elementType: 'all',
                stylers: [
                  {
                    visibility: 'on',
                  },
                ],
              },
              {
                featureType: 'all',
                elementType: 'labels',
                stylers: [
                  {
                    visibility: 'on',
                  },
                ],
              },
              {
                featureType: 'administrative',
                elementType: 'labels',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
              {
                featureType: 'administrative.neighborhood',
                elementType: 'labels',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
              {
                featureType: 'landscape',
                elementType: 'labels',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
              {
                featureType: 'landscape.man_made',
                elementType: 'labels',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
              {
                featureType: 'landscape.natural',
                elementType: 'all',
                stylers: [
                  {
                    visibility: 'on',
                  },
                ],
              },
              {
                featureType: 'poi',
                elementType: 'all',
                stylers: [
                  {
                    visibility: 'on',
                  },
                ],
              },
              {
                featureType: 'poi',
                elementType: 'labels',
                stylers: [
                  {
                    visibility: 'off',
                  },
                ],
              },
            ],
          };

          // create map
          var map = new google.maps.Map($el[0], args);

          // add a markers reference
          map.markers = [];

          // add markers
          $markers.each(function () {
            add_marker($(this), map);
          });

          // center map
          center_map(map);

          // return
          return map;
        }

        function add_marker($marker, map) {
          // var
          var latlng = new google.maps.LatLng(
            $marker.attr('data-lat'),
            $marker.attr('data-lng')
          );

          var icon = $marker.attr('data-icon');

          // create marker
          var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            icon: 'https://sjcp.tlp.dev/wp-content/themes/SJCP/assets/images/map-pin.svg',
          });

          // add to array
          map.markers.push(marker);

          // if marker contains HTML, add it to an infoWindow
          if ($marker.html()) {
            // create info window
            var infowindow = new google.maps.InfoWindow({
              content: $marker.html(),
            });

            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function () {
              infowindow.open(map, marker);
            });
          }
        }

        function center_map(map) {
          // vars
          var bounds = new google.maps.LatLngBounds();

          // loop through all markers and create bounds
          $.each(map.markers, function (i, marker) {
            var latlng = new google.maps.LatLng(
              marker.position.lat(),
              marker.position.lng()
            );

            bounds.extend(latlng);
          });

          // only 1 marker?
          if (map.markers.length == 1) {
            // set center of map
            map.setCenter(bounds.getCenter());
            map.setZoom(18);
          } else {
            // fit to bounds
            map.fitBounds(bounds);
          }
        }

        // global var
        var map = null;

        $('.acf-map').each(function () {
          // create map
          map = new_map($(this));
        });

        function new_location(href) {
          // alert('going somewhere?');
          // do special/fade stuff?
          window.location.href = href;
        }

        //  $('.entry-content iframe').reframe();

        var $hamburger = $('#menu-hamburger');
        $hamburger.on('click', function (e) {
          e.preventDefault();
          $hamburger.toggleClass('is-active');
        });

        $(window).on('scroll', function () {
          if ($(this).scrollTop() > 85) {
            //$('#menu-hamburger .hamburger-text').show();
            $('#menu-hamburger').addClass('fixed-hamburger');
          } else {
            //$('#menu-hamburger .hamburger-text').hide();
            $('#menu-hamburger').removeClass('fixed-hamburger');
          }
        });

        var $jsoverlay = $('.js-off-canvas-overlay');
        $(document).on('click', '.js-off-canvas-overlay', function (e) {
          e.preventDefault();
          $hamburger.removeClass('is-active');
          $hamburger.removeClass('menu-fixed-hamburger');
        });

        $(document).on('close.zf.offCanvas', function (event) {
          //$('.pagination').css('display','block');
          $hamburger.removeClass('is-active');
          $hamburger.removeClass('menu-fixed-hamburger');
          $('#main-menu-side .mobile-nested-menu-content').removeClass('active');
          $('#off-canvas').removeClass('drill-open');
          $('body').removeClass('drill-open');
          $('html').removeClass('drill-open');
        });

        $(document).on('opened.zf.offCanvas', function (event) {
          //$('.pagination').css('display','block');
          $hamburger.addClass('menu-fixed-hamburger');
        });


        $('.sidebar_menu').on('click', '.close-drill-button', function (e) {
          e.preventDefault();
          $('#off-canvas').removeClass('drill-open');
          $('body').removeClass('drill-open');
          $('html').removeClass('drill-open');
          $('#main-menu-side .mobile-nested-menu-content').removeClass('active');
        });

        $('.sidebar_menu').on('click', '.close-drill', function (e) {
          e.preventDefault();

          // $('#main-menu-side').foundation('_hideAll');
          // $('#main-menu-side li.is-drilldown-submenu-parent').attr(
          //   'aria-expanded',
          //   false
          // );
          $('#off-canvas').removeClass('drill-open');
          $('body').removeClass('drill-open');
          $('html').removeClass('drill-open');
          $('#main-menu-side .mobile-nested-menu-content').removeClass('active');

          //$(this).next().find('.js-drilldown-back').trigger('click');

          //    $elem = $(this).parent();
          //$('#main-menu').foundation('_back', $elem);
        });


        // $(document).on('open.zf.drilldown', function (event) {
        //   $('.sidebar_menu').addClass('noscroll');
        //   $('#off-canvas').addClass('noscroll');
        // });

        // $(document).on('close.zf.drilldown', function (event) {
        //   $('.sidebar_menu').removeClass('noscroll');
        //   $('#off-canvas').removeClass('noscroll');
        // });
        
        console.log('loaded');

        $('#main-menu-side').on('click', 'a.has-children', function(e){
          e.preventDefault();
          console.log('clicked');

          $('#main-menu-side .mobile-nested-menu-content').removeClass('active');
          $(this).parent().find('.mobile-nested-menu-content').addClass('active');

          $('#off-canvas').addClass('drill-open');
          $('body').addClass('drill-open');
          $('html').addClass('drill-open');

        });

        

        
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function () {
        // JavaScript to be fired on the about us page
      },
    },
    contact: {
      init: function () {},
    },
    single_product: {
      finalize: function () {
        // Woocommerce Tabs

        $('.woocommerce-Tabs-panel h2').click(function () {
          $(this).parents('.woocommerce-Tabs-panel').toggleClass('active');
          $(this).parent().next('#review_form_wrapper').slideToggle('slow');
          $(this).next('p, ol').slideToggle('slow');
        });

        $('.woocommerce-review-link').click(function () {
          $('#review_form_wrapper, .commentlist').slideToggle('slow');
        });
      },
    },
    checkout: {
      init: function () {
        $('.form-row').each(function () {
          $(this).find('.woocommerce-input-wrapper input').prependTo(this);

          if ($(this).find('input').val() != '') {
            $(this).addClass('has-val');
          }

          $(this).find('input').attr('placeholder', '');
        });

        $('.form-row').change(function () {
          $(this).addClass('has-val');
        });
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = mirai;
      funcname = funcname === undefined ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, '_').split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, 'finalize');
        }
      );

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);


  jQuery(document).ready(function () {
    load_donorfy();
  });


//@prepros-prepend ./vendor/*.js


function GetBaseServiceUrl() {
  return "https://api.donorfy.com/api/stripe/";
}

function load_donorfy() {

  $('#donorfy-stripe-select').on('click', '.amt-button', function(e){
    e.preventDefault();
    var amt = $(this).data('amt');

    $('#Amount').val(amt);

    $('.amt-button').addClass('hollow');

    $(this).removeClass('hollow');

  });


  $('#donorfy-card-steps').slick({
    arrows: false,
    dots: true,
    slidesToShow: 1,
    adaptiveHeight: true,
    autoplay: false,
    fade: true,
  });



  $('.slick-form-menu').on('click', 'li', function (e) {
    //alert('click');
    e.preventDefault();
    e.stopPropagation();
    var slickSlider = $(this)
      .closest('form')
      .find('.slick-slider');

    var index = $(this).index();

    slickSlider.slick('slickGoTo', index);

    $(this).siblings().removeClass('active');
          $(this).addClass('active');
    //slickSlider.slick('slickNext');
  });


  $('.donation-widget-form').on('click', '.next-step', function (e) {
    //alert('click');
    e.preventDefault();
    e.stopPropagation();
    var slickSlider = $(this)
      .closest('form')
      .find('.slick-slider');


    slickSlider.slick('slickNext');
  });


  $('#donorfy-card-steps').on(
    'beforeChange',
    function (e, s, currentSlide, nextSlide) {
      //let previousSlideIndex = currentSlideIndex - 1;
      //console.log(previousSlideIndex);

      var menu = $(this).closest('form').find('.menu');

      menu.find('li').removeClass('active');

      menu.find('li').eq(nextSlide).addClass('active');
    }
  );


  $('#toggle-one-off').on(
    'click',
    function (e) {
      e.preventDefault();
      // OneOffPayment
      // toggle-one-off
      // RecurringPayment
      // toggle-recurring

      $(this).addClass('active');
      $(this).removeClass('hollow');
      $('#toggle-recurring').removeClass('active');
      $('#toggle-recurring').addClass('hollow');

      //$("#RecurringPayment").prop("checked", false);
      $("#OneOffPayment").prop("checked", true);
      
      
    }
  );

  $('#toggle-recurring').on(
    'click',
    function (e) {
      e.preventDefault();
      // OneOffPayment
      // toggle-one-off
      // RecurringPayment
      // toggle-recurring

      $(this).addClass('active');
      $(this).removeClass('hollow');
      $('#toggle-one-off').removeClass('active');
      $('#toggle-one-off').addClass('hollow');

      //$("#RecurringPayment").prop("checked", false);
      $("#RecurringPayment").prop("checked", true);
      
      
    }
  );
  



  if (typeof jQuery.validator === 'undefined') {
      loadScript('https://ajax.aspnetcdn.com/ajax/jquery.validate/1.13.1/jquery.validate.min.js');
  }

  var payPayClientId = jQuery('#PayPalClientId').val(); 
  var uCurrency = DonorfyWidget.Currency.toUpperCase();
   
  // if (payPayClientId !== undefined && payPayClientId !== "" ){
  //     var payPalScript = "https://www.paypal.com/sdk/js?client-id=" + payPayClientId + "&disable-funding=credit,card&currency=" + uCurrency;
  //     loadScript(payPalScript);
  // };   //tj removed


  var code = jQuery('#TenantCode').val();
  var id = jQuery('#WidgetId').val();
  if (id === "") {
      id = jQuery('#DonationPageId').val();
  }
  
  ResetErrorMessage(); //tj added

  jQuery.ajax({
      dataType: 'json',
      url: GetBaseServiceUrl() + 'P0?id=' + id + '&code=' + code,
      method: 'POST',
      type: 'POST'
  }).done(function (data) {

      if (data.OK) {
          jQuery('#spinner').hide();
          var key = data.RequestData;
          DonorfyWidget.Stripe = Stripe(key);
          DonorfyWidget.Elements = DonorfyWidget.Stripe.elements();
          DonorfyWidget.StripeStatementText = jQuery('#StripeStatementText').val();
          DonorfyWidget.PayPalStatementText = jQuery('#PayPalStatementText').val();

          var currencyCodeOverride = jQuery('#CurrencyCode').val();
          if (currencyCodeOverride !== undefined && currencyCodeOverride !== "") {
              DonorfyWidget.Currency = currencyCodeOverride;
          }

          var countryCodeOverride = jQuery('#CountryCode').val();
          if (countryCodeOverride !== undefined && countryCodeOverride !== "") {
              DonorfyWidget.Country = countryCodeOverride;
          }

          window.cardNumber = DonorfyWidget.Elements.create('cardNumber');
          window.cardNumber.mount('#card-number');

          window.cardExpiry = DonorfyWidget.Elements.create('cardExpiry');
          cardExpiry.mount('#card-expiry');

          window.cardCvc = DonorfyWidget.Elements.create('cardCvc');
          cardCvc.mount('#card-cvc');

          var submitButton = document.getElementById('submitButton');
          submitButton.addEventListener('click',
              function (ev) {
                  DisableSubmitButton();
                  ResetErrorMessage();
                  if (ValidateForm()) {
                      try {
                          Process();
                      } catch (e) {
                          EnableSubmitButton();
                          console.log('Exception  ' + e);
                          ev.preventDefault();
                          return false;
                      }

                  } else {
                      EnableSubmitButton();
                      DisplayErrorMessage('please scroll up to see the details and check previous steps');
                  }
                  ev.preventDefault();
                  return false;
              });


          jQuery('input.numberOnly[type=text]').on('keypress',
              function (e) {
                  if (e.which !== 8 &&
                      e.which !== 44 &&
                      e.which !== 45 &&
                      e.which !== 46 &&
                      e.which !== 0 &&
                      (e.which < 48 || e.which > 57)) {
                      return false;
                  }
                  return true;
              });

          jQuery('input#Amount').blur(function () {

              if (this.value) {
                  var amt = parseFloat(this.value);
                  jQuery(this).val(amt.toFixed(2));
              }
              SetUpApplePay();
              SetUpPayPal();
          });

          //jQuery('input#Amount').keyup(function (event) {
          //    SetUpApplePay();
          //    SetUpPayPal();
          //});

          jQuery("input[name='PaymentType']").on("click",
              function () {

                  if (jQuery(this).val() === 'Recurring') {
                      jQuery('#PaymentScheduleRow').show();
                      document.getElementById('payment-request-button').style.display = 'none';
                      document.getElementById('paypal-button-container').style.display = 'none';
                  } else {
                      jQuery('#PaymentScheduleRow').hide();
                      document.getElementById('payment-request-button').style.display = '';
                      document.getElementById('paypal-button-container').style.display = '';
                  }
              });

          try {
              InitialiseForm();
          } catch (e) {
              console.log('Exception calling InitialiseForm() ' + e);
          }
      } else {
          DisplayErrors(data.Errors);
      }
  }).fail(function (jqXHR, textStatus, errorThrown) {
      DisplayErrors(GetErrorArray(jqXHR));
      

     
      return "";
  });
  return "";
}

var DonorfyWidget =
{
  Country: 'GB',
  Currency: 'gbp',
  Stripe: null,
  Elements: null,
  StripePaymentRequest: null,
  StripePaymentRequestButton: null,
  StripeStatementText: '',
  PayPal: null,
  PayPalStatementText: '',
  PayPalLoaded: false
}

function SetUpPayPal() {

  if (jQuery('#PalPayEnabled').val() === 'No') {
      return;
  }

  var payPayClientId = jQuery('#PayPalClientId').val(); 
  if (payPayClientId === undefined || payPayClientId === "" || payPayClientId === 'none'){
      return;
  }
  

  var donAmt = jQuery('#Amount').val();
  if (donAmt === undefined || donAmt === "" || donAmt === 'none') {
      if ($('#payment-request-button').length) {
          document.getElementById('paypal-button-container').style.display = 'none';
      }
      return;
  }
  
  if (donAmt === 0) {
      if ($('#payment-request-button').length) {
          document.getElementById('paypal-button-container').style.display = 'none';
      }
      return;
  }
  else {
    donAmt = parseFloat(donAmt).toFixed(2);
  }

  if (jQuery("#OneOffPayment").prop("checked")) {
      document.getElementById('paypal-button-container').style.display = '';
  }
  else {
      document.getElementById('paypal-button-container').style.display = 'none';
  }

  

  $('#paypal-button-container').html('');
  var uCurrency = DonorfyWidget.Currency.toUpperCase();
  try {

      DonorfyWidget.PayPal = paypal.Buttons({
          createOrder: function (data, actions) {
              if (!ValidateForm()) {
                  return false;
              }
              return actions.order.create({
                  purchase_units: [{
                      amount: {
                          value: donAmt,
                          currency_code: uCurrency
                      },
                      soft_descriptorstring: DonorfyWidget.PayPalStatementText
                      , description: DonorfyWidget.PayPalStatementText
                  }]
              });
          },
          onApprove: function (data, actions) {
              return actions.order.capture().then(function (details) {
                  $('#PayPal').val('Yes');
                  $('#ExternalPaymentReference').val(details.id);
                  PostPayment(details.id);
              });
          }
      }).render('#paypal-button-container');
  } catch (e) {
      console.log('SetUpPayPal ' + e);
  }


}

function SetUpApplePay() {

  if (jQuery('#ApplePayEnabled').val() === 'No') {
      return;
  }


  var donAmt = jQuery('#Amount').val();
  if (donAmt === undefined || donAmt === "" || donAmt === 'none') {
      if ($('#payment-request-button').length) {
          document.getElementById('payment-request-button').style.display = 'none';
      }
      return;
  }

  donAmt = Math.round(donAmt * 100);
  if (donAmt === 0) {
      if ($('#payment-request-button').length) {
          document.getElementById('payment-request-button').style.display = 'none';
      }
      return;
  }



  if ($('#payment-request-button').length) {
      try {
          // Apply pay btn
          if (DonorfyWidget.StripePaymentRequest === null) {
              DonorfyWidget.StripePaymentRequest = DonorfyWidget.Stripe.paymentRequest({
                  country: DonorfyWidget.Country,
                  currency: DonorfyWidget.Currency,
                  total: {
                      label: DonorfyWidget.StripeStatementText,
                      amount: donAmt
                  },
                  requestPayerName: true,
                  requestPayerEmail: true
              });
              DonorfyWidget.StripePaymentRequestButton = DonorfyWidget.Elements.create('paymentRequestButton', {
                  paymentRequest: DonorfyWidget.StripePaymentRequest
              });
          } else {
              DonorfyWidget.StripePaymentRequest.update({
                  total: {
                      label: DonorfyWidget.StripeStatementText,
                      amount: donAmt
                  }
              });
          }


          // Check the availability of the Payment Request API first.
          DonorfyWidget.StripePaymentRequest.canMakePayment().then(function (result) {
              if (result) {
                  DonorfyWidget.StripePaymentRequestButton.mount('#payment-request-button');
              } else {
                  document.getElementById('payment-request-button').style.display = 'none';
              }
          });

          DonorfyWidget.StripePaymentRequest.on('paymentmethod',
              function (ev) {
                  ValidateStripeApplePayRequest(ev);
              });

          document.getElementById('payment-request-button').style.display = 'none';
          if (!jQuery('#RecurringPayment').is(':checked')) {
              document.getElementById('payment-request-button').style.display = '';
          }

      } catch (e) {
          console.log('SetUpApplePay ' + e);
      }
  }
}

// Validates and processes Apple Pay via Stripe  
function ValidateStripeApplePayRequest(ev) {
  if (ValidateForm()) {
      var code = $('#TenantCode').val();
      var email = $('#Email').val();
      var emailEnc = encodeURIComponent(email);
      var recurring = jQuery('#RecurringPayment').is(':checked');


      var donAmt = jQuery('#Amount').val();
      if (donAmt === undefined || donAmt === "" || donAmt === 'none') {
          if ($('#payment-request-button').length) {
              document.getElementById('payment-request-button').style.display = 'none';
          }
          return;
      }

      donAmt = Math.round(donAmt * 100);
      if (donAmt === 0) {
          if ($('#payment-request-button').length) {
              document.getElementById('payment-request-button').style.display = 'none';
          }
          return;
      }

      var id = jQuery('#WidgetId').val();
      if (id === "") {
          id = jQuery('#DonationPageId').val();
      }

      var siteKey = jQuery('#ReCaptchaSiteKey').val();
      var action = jQuery('#ReCaptchaAction').val();

      try {
          grecaptcha.ready(function () {
              grecaptcha.execute(siteKey, { action: action }).then(function (token) {
                  DisableSubmitButton();
                  jQuery.ajax({
                      dataType: 'json',
                      url: GetBaseServiceUrl() +
                          'P1?id=' +
                          id +
                          '&code=' +
                          code +
                          '&amount=' +
                          donAmt +
                          '&email=' +
                          emailEnc +
                          '&rec=' +
                          recurring +
                          '&token=' +
                          token,
                      method: 'POST',
                      type: 'POST'
                  }).done(function (data) {
                      if (data.OK) {
                          jQuery('#submitButton').attr('data-secret', data.RequestData);
                          DonorfyWidget.Stripe.confirmCardPayment(data.RequestData,
                              { payment_method: ev.paymentMethod.id },
                              { handleActions: false }
                          ).then(function (confirmResult) {
                              if (confirmResult.error) {
                                  ValidateForm();
                                  DisplayErrorMessage(result.error.message);
                                  ev.complete('fail');
                                  return false;
                              } else {
                                  $('#StripePaymentIntentId').val(confirmResult.paymentIntent.id);
                                  PostPayment(confirmResult.paymentIntent.id);
                                  ev.complete('success');
                                  // Check if the PaymentIntent requires any actions and if so let Stripe.js
                                  // handle the flow. If using an API version older than "2019-02-11" instead
                                  // instead check for: `paymentIntent.status === "requires_source_action"`.
                                  if (confirmResult.paymentIntent.status === "requires_action") {
                                      // Let Stripe.js handle the rest of the payment flow.
                                      DonorfyWidget.Stripe.confirmCardPayment(data.RequestData).then(
                                          function (result) {
                                              if (result.error) {
                                                  // The payment failed -- ask your customer for a new payment method.
                                                  ValidateForm();
                                                  DisplayErrorMessage(result.error.message);
                                                  return false;
                                              } else {
                                                  // The payment has succeeded.
                                                  $('#StripePaymentIntentId').val(result.paymentIntent.id);
                                                  $('#PaymentMethod').val('ApplePay');
                                                  PostPayment(result.paymentIntent.id);
                                                  return true;
                                              }
                                          });
                                  } else {
                                      // The payment has succeeded.
                                      $('#StripePaymentIntentId').val(result.paymentIntent.id);
                                      PostPayment(result.paymentIntent.id);
                                      return true;
                                  }
                                  return true;
                              }
                          });
                      }
                  }).fail(function (jqXHR, textStatus, errorThrown) {
                      console.log('ValidateStripeApplePayRequest jqXHR ' + jqXHR);
                      DisplayErrorMessage(GetErrorArray(jqXHR));
                      return false;
                  });
              });
          });
      } catch (e) {
          console.log('Exception in ValidateStripeApplePayRequest ' + e);
          DisplayErrorMessage(e);
          return false;
      }
  }
  else {
      return false;
  }
}

function loadScript(url, successFunction) {

  var script = document.createElement('script');
  script.src = url;
  var head = document.getElementsByTagName('head')[0],
      done = false;
  head.appendChild(script);
  script.onload = script.onreadystatechange = function () {
      if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
          done = true;

          if (successFunction) {
              successFunction();
          }
          script.onload = script.onreadystatechange = null;
          head.removeChild(script);
      }
  };
}

function Initialise() {
  var code = jQuery('#TenantCode').val();
  var id = jQuery('#WidgetId').val();
  if (id === "") {
      id = jQuery('#DonationPageId').val();
  }
  jQuery.ajax({
      dataType: 'json',
      url: GetBaseServiceUrl() + 'P0?id=' + id + '&code=' + code,
      method: 'POST',
      type: 'POST'
  }).done(function (data) {

      if (data.OK) {
          return data.RequestData;
      } else {
          DisplayErrors(data.Errors);
      }
  }).fail(function (jqXHR, textStatus, errorThrown) {
      DisplayErrors(GetErrorArray(jqXHR));
      return "";
  });
  return "";
}

function ValidateForm() {
  jQuery('#CreditCardForm').validate().settings.ignore = ':disabled,:hidden';
  return jQuery('#CreditCardForm').valid();
}


function Process() {

  var code = jQuery('#TenantCode').val();
  var email = jQuery('#Email').val();
  var emailEnc = encodeURIComponent(email);
  var recurring = jQuery('#RecurringPayment').is(':checked');
  var id = jQuery('#WidgetId').val();
  if (id === "") {
      id = jQuery('#DonationPageId').val();
  }
  var amount = jQuery('#Amount').val();
  amount = amount.replace(/\D/g, '');

  var firstName = jQuery('#FirstName').length > 0 ? jQuery('#FirstName').val() : '';
  var lastName = jQuery('#LastName').length > 0 ? jQuery('#LastName').val() : '';
  var town = jQuery('#Town').length > 0 ? jQuery('#Town').val() : '';
  var address2 = jQuery('#Address2').length > 0 ? jQuery('#Address2').val() : '';
  var address1 = jQuery('#Address1').length > 0 ? jQuery('#Address1').val() : '';
  var postcode = jQuery('#Postcode').length > 0 ? jQuery('#Postcode').val() : '';
  var county = jQuery('#County').length > 0 ? jQuery('#County').val() : '';


  var siteKey = jQuery('#ReCaptchaSiteKey').val();
  var action = jQuery('#ReCaptchaAction').val();

  try {
      grecaptcha.ready(function () {
          grecaptcha.execute(siteKey, { action: action }).then(function (token) {
              jQuery.ajax({
                  dataType: 'json',
                  url: GetBaseServiceUrl() +
                      'P1?id=' +
                      id +
                      '&code=' +
                      code +
                      '&amount=' +
                      amount +
                      '&email=' +
                      emailEnc +
                      '&rec=' +
                      recurring +
                      '&token=' +
                      token,
                  method: 'POST',
                  type: 'POST'
              }).done(function (data) {
                  if (data.OK) {
                      jQuery('#submitButton').attr('data-secret', data.RequestData);
                      DonorfyWidget.Stripe.handleCardPayment(data.RequestData,
                          cardNumber,
                          {
                              save_payment_method: recurring,
                              receipt_email: email,
                              payment_method_data: {
                                  billing_details: {
                                      name: firstName + ' ' + lastName,
                                      email: email,
                                      address: {
                                          city: town,
                                          line1: address1,
                                          line2: address2,
                                          postal_code: postcode,
                                          state: county
                                      }
                                  }
                              }
                          }).then(function (result) {
                              if (result.error) {
                                  DisplayErrorMessage(result.error.message);
                              } else {
                                  PostPayment(result.paymentIntent.id);
                              }
                          });
                      var requestData = data.RequestData;
                      return requestData;
                  } else {
                      DisplayErrors(data.Errors);
                  }
              }).fail(function (jqXHR, textStatus, errorThrown) {
                  DisplayErrors(GetErrorArray(jqXHR));
              });
          });
      });
  } catch (e) {
      console.log('Exception in Process ' + e);
  }
}


function PostPayment(token) {

  jQuery.ajax({
      dataType: 'json',
      url: GetBaseServiceUrl() + 'P2',
      data: GetPaymentPostData(token),
      method: 'POST',
      type: 'POST'
  }).done(function (data) {

      if (data.OK) {
          Completed();
      } else {
          DisplayErrors(data.Errors);
      }

  }).fail(function (jqXHR, textStatus, errorThrown) {
      DisplayErrors(GetErrorArray(jqXHR));
  });

}


function EnableSubmitButton() {
  jQuery('#submitButton').removeAttr('disabled');
  if (jQuery('#DonationPageId').val() !== '') {
      jQuery('#submitButton').text('reset');
  }
  jQuery('#PleaseWait').hide();
}

function DisableSubmitButton() {
  if (jQuery('#DonationPageId').val() !== '') {
      jQuery('#submitButton').text('loading');
  }
  jQuery('#submitButton').attr('disabled', 'disabled');
  jQuery('#PleaseWait').show();
}



function GetPaymentPostData(stripeToken) {

  return {
      title: jQuery('#Title').val(),
      firstName: jQuery('#FirstName').val(),
      lastName: jQuery('#LastName').val(),
      email: jQuery('#Email').val(),
      phone: jQuery('#Phone').val(),
      address1: jQuery('#Address1').val(),
      address2: jQuery('#Address2').val(),
      town: jQuery('#Town').val(),
      county: jQuery('#County').val(),
      postCode: jQuery('#Postcode').val(),
      country: jQuery('#Country').length > 0 ? jQuery('#Country').val() : '',
      token: stripeToken,
      giftAid: jQuery('#GiftAid').is(':checked'),
      keepInTouch: GetKeepInTouchValue(),
      doNotKeepInTouch: GetDoNotKeepInTouchValue(),
      optInShown: GetOptInShownValue(),
      legitInterestShown: GetLegitInterestShownValue(),
      amount: jQuery('#Amount').val(),
      cardType: jQuery('#CardType').val(),
      tenantCode: jQuery('#TenantCode').val(),
      widgetId: jQuery('#WidgetId').val(),
      recurring: jQuery('#RecurringPayment').is(':checked'),
      paymentSchedule: jQuery('input:radio[name=PaymentSchedule]:checked').val(),
      donationPageId: jQuery('#DonationPageId').val(),
      comment: jQuery('#Comment').val(),
      quantity: jQuery('#Quantity').length > 0 ? jQuery('#Quantity').val() : '1',
      additionalTitle: jQuery('#AdditionalTitle').length > 0 ? jQuery('#AdditionalTitle').val() : '',
      additionalFirstName: jQuery('#AdditionalFirstName').length > 0 ? jQuery('#AdditionalFirstName').val() : '',
      additionalLastName: jQuery('#AdditionalLastName').length > 0 ? jQuery('#AdditionalLastName').val() : '',
      additionalEmail: jQuery('#AdditionalEmail').length > 0 ? jQuery('#AdditionalEmail').val() : '',
      additionalPhone: jQuery('#AdditionalPhone').length > 0 ? jQuery('#AdditionalPhone').val() : '',
      additionalAddress1: jQuery('#AdditionalAddress1').length > 0 ? jQuery('#AdditionalAddress1').val() : '',
      additionalAddress2: jQuery('#AdditionalAddress2').length > 0 ? jQuery('#AdditionalAddress2').val() : '',
      additionalTown: jQuery('#AdditionalTown').length > 0 ? jQuery('#AdditionalTown').val() : '',
      additionalCounty: jQuery('#AdditionalCounty').length > 0 ? jQuery('#AdditionalCounty').val() : '',
      additionalPostcode: jQuery('#AdditionalPostcode').length > 0 ? jQuery('#AdditionalPostcode').val() : '',
      additionalCountry: jQuery('#AdditionalCountry').length > 0 ? jQuery('#AdditionalCountry').val() : '',
      activeTags: jQuery('#ActiveTags').length > 0 ? jQuery('#ActiveTags').val() : '',
      blockedTags: jQuery('#BlockedTags').length > 0 ? jQuery('#BlockedTags').val() : '',
      useAdditionalDetails: jQuery('#UseAdditionalDetails').length > 0 ? jQuery('#UseAdditionalDetails').val() : '',
      externalPaymentReference: jQuery('#ExternalPaymentReference').length > 0 ? jQuery('#ExternalPaymentReference').val() : '',
      payPal: jQuery('#PayPal').length > 0 ? jQuery('#PayPal').val() : ''
  };
}

function GetOptInShownValue() {

  var keepInTouchValue = 0;

  jQuery('input.KeepInTouch[type=checkbox]').each(function () {
      keepInTouchValue += parseInt(jQuery(this).val());
  });

  return keepInTouchValue;
}

function GetLegitInterestShownValue() {

  var doNotKeepInTouchValue = 0;

  jQuery('input.DoNotKeepInTouch[type=checkbox]').each(function () {
      doNotKeepInTouchValue += parseInt(jQuery(this).val());
  });

  return doNotKeepInTouchValue;
}


function GetKeepInTouchValue() {

  var keepInTouchValue = 0;

  jQuery('input.KeepInTouch[type=checkbox]:checked').each(function () {
      keepInTouchValue += parseInt(jQuery(this).val());
  });

  return keepInTouchValue;
}

function GetDoNotKeepInTouchValue() {

  var doNotKeepInTouchValue = 0;

  jQuery('input.DoNotKeepInTouch[type=checkbox]:checked').each(function () {
      doNotKeepInTouchValue += parseInt(jQuery(this).val());
  });

  return doNotKeepInTouchValue;
}

function GetErrorArray(jqXHR) {

  var errors = [];

  var response = JSON.parse(jqXHR.responseText);

  if (response.ModelState) {
      for (var key in response.ModelState) {
          errors.push(response.ModelState[key]);
      }
  } else if (response.Message) {
      errors.push(response.Message);
  } else {
      errors.push('An unexpected error occurred.');
  }

  return errors;
}

function DisplayErrors(errors) {
  var errorMessage = '';
  jQuery.each(errors, function (index, value) {
      errorMessage += value + '<br/>';
  });
  DisplayErrorMessage(errorMessage);
}

function ResetErrorMessage() {
  jQuery('#Errors').html('');
  jQuery('#ErrorContainer').hide();
}

function DisplayErrorMessage(errorMessage) {
  jQuery('#PleaseWait').hide();
  jQuery('#ErrorContainer').show();
  jQuery('#Errors').html(errorMessage);
  EnableSubmitButton();
//  $('#donorfy-card-steps').slick().animateHeight(); //tj
  $(window).trigger('resize');//tj
}

function Completed() {
  var redirectToPage = jQuery('#RedirectToPage').val();
  if (redirectToPage) {
      window.location = redirectToPage;
  } else {
      window.location = '/';
  }
}

})(jQuery); // Fully reference jQuery after this point.